import { TODAY, VIEWS } from './constants';
import { addDays } from './utils/dates';

/* ── Composant principal ── */
export function migrateState(raw) {
  // Migration de l'ancien format projets[] → clients[] avec phases[]
  if (raw.clients) return raw;
  if (raw.projets) {
    const clients = raw.projets.map((p) => ({
      id: p.id,
      nom: p.nom,
      jira_project_key: p.jira_project_key || '',
      phases: [
        {
          id: 'ph_' + p.id,
          nom: 'Phase 1',
          facturation: p.facturation || 'forfait_brique',
          dateDebut: '',
          dateFin: null,
          briques: p.briques || [],
          montantGlobal: p.montantGlobal || '',
          joursTotal: p.joursTotal || '',
          tjm: p.tjm || '',
          nbDevs: p.nbDevs || '',
          dureeMois: p.dureeMois || '',
          correctifQte: p.heuresMensuelles || '',
          correctifUnite: 'heures_mois',
          tauxHoraire: p.tauxHoraire || '',
          evolutifQte: p.joursAnnuels || '',
          evolutifUnite: 'jours_an',
          echeance: p.echeance || '',
          dateFinContrat: p.dateFinContrat || '',
        },
      ],
    }));
    const { projets: _, ...rest } = raw;
    return { ...rest, clients };
  }
  return raw;
}

export function loadUiPrefs() {
  try {
    const s = localStorage.getItem('pdc3_ui');
    if (s) {
      const p = JSON.parse(s);
      return {
        view: p.view || VIEWS.TIMELINE,
        tlStart: p.tlStart ? new Date(p.tlStart) : addDays(TODAY, -7),
        tlDays: p.tlDays || 60,
      };
    }
    // Fallback : lire tlStart/tlDays depuis l'ancien pdc3
    const old = localStorage.getItem('pdc3');
    if (old) {
      const p = JSON.parse(old);
      return {
        view: p.view || VIEWS.TIMELINE,
        tlStart: p.tlStart ? new Date(p.tlStart) : addDays(TODAY, -7),
        tlDays: p.tlDays || 60,
      };
    }
  } catch (e) {}
  return null;
}

export const DEFAULT_STATE = {
  view: VIEWS.TIMELINE,
  devs: [],
  clients: [],
  affectations: [],
  tlStart: addDays(TODAY, -7),
  tlDays: 60,
  _hasLocalData: false,
};
